
import axios from 'axios'
import wx from 'weixin-js-sdk'
export default {

  wxShowMenu: function() {
    // console.log(location.href)
    axios.post('https://api.captainbank.com/mpapi/captainbank/wechat/getSignature', { 'url': location.href }).then(function(res) {
      var getMsg = res.data.result

      wx.config({

        debug: false, // 生产环境需要关闭debug模式

        appId: 'wxd4ca91a5aa237d17', // appId通过微信服务号后台查看

        timestamp: getMsg.timestamp, // 生成签名的时间戳

        nonceStr: getMsg.nonceStr, // 生成签名的随机字符串

        signature: getMsg.signature, // 签名

        jsApiList: [ // 需要调用的JS接口列表

          'updateTimelineShareData', // 分享给好友

          'updateAppMessageShareData', // 分享到朋友圈

          'showMenuItems'

        ]

      })

      wx.ready(function() {
        wx.checkJsApi({

          jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData', 'showMenuItems'],

          success: function(res) {
            wx.showMenuItems({

              menuList: [

                'menuItem:share:appMessage', // 发送给朋友

                'menuItem:share:timeline' // 分享到朋友圈

              ]

            })
          }

        })

        // 分享到朋友圈

        wx.updateTimelineShareData({

          title: '凯璞庭集团', // 分享标题

          link: location.href, // 分享链接

          imgUrl: 'https://static.joinzs.com/img/captainbank/logo/logo.png' // 分享图标

        })

        // 分享给朋友

        wx.updateAppMessageShareData({

          title: '凯璞庭集团', // 分享标题

          link: location.href, // 分享链接

          desc: '我们致力于通过“债务化解、平台转型、招商引智”,全逻辑解决方案促进中国区域经济发展及产业升级。', // 分享描述

          imgUrl: 'https://static.joinzs.com/img/captainbank/logo/logo.png' // 分享图标

        })
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/wxApi.js